import Cookies from 'js-cookie';

export const COOKIE_AGREE = 'privacy-policy-cookie-consent';
export const COOKIE_USER_ID = 'fid';
export const COOKIE_CLIENT_ID = '_ga';
export const COOKIE_CONSENT = 'cookie-all-accepted-at-once';

const SECONDS_PER_DAY = 60 * 60 * 24;

export const YEAR_IN_SECONDS = 365 * SECONDS_PER_DAY;
export const COOKIE_AGREE_DEFAULT_TIMEOUT = 150 * SECONDS_PER_DAY;

export const setCookies = (key: string, value: string, options?: Cookies.CookieAttributes) => {
  const cookieOptions = {
    path: '/',
    ...options,
  };

  Cookies.set(key, value, cookieOptions);

  return value;
};

const generateValue = (key: string, value = '') => {
  switch (key) {
    case COOKIE_USER_ID:
      return setCookies(key, value, { 'max-age': YEAR_IN_SECONDS.toString() });
    default:
      return '';
  }
};

export const getCookie = (key: string, defaultValue?: string) => {
  const value = Cookies.get(key);

  return value || generateValue(key, defaultValue);
};

const getUserId = (defaultValue: string): string => {
  const cookieGAClientId = Cookies.get(COOKIE_CLIENT_ID);

  return cookieGAClientId || getCookie(COOKIE_USER_ID, defaultValue);
};

export const getAnalyticsData = async () => {
  const exactTime = Date.now().toString();

  return {
    user_id: getUserId(exactTime),
  };
};

export const removeCookies = async (key: string) => {
  Cookies.remove(key, { path: '/' });
};

export const isCookieSet = (key: string): boolean => !!Cookies.get(key);
